export default "__VITE_ASSET__YjxS$2d2__"